export default __webpack_public_path__ + "static/media/eventifyFacebook-1200x630.d7963065.jpg";